import type { Reader } from '@/composables/payments/booksy-card-reader'

export const FLASH_DATA_KEYS = {
  CUSTOMER_LIST_PATCH: 'customers.list-patch',
  INVENTORY_DOCUMENT_CREATE: 'inventory.documents.create',
  INVOICE_DEFAULT: 'sales.invoices.new',
  MESSAGE_CLIENTS_CUSTOMERS: 'message-clients.customers',
  MESSAGE_CLIENTS_OPTIONS: 'message-clients.options',
  MESSAGE_CLIENTS_PROMOTIONS_TEMPLATE: 'message-clients.promotions-template',
  PARTNER_APP_NOTIFICATION_PARAMS: 'partner-app.notification-params',
  SOCIAL_POST_CREATOR: 'promotion.social-media',
  BCR_CONNECT: 'payments.booksy-card-reader.connect',
} as const

export type SocialPostCreatorFlashData = {
  socialPostCreatorOpened?: boolean
  image?: unknown
  flyer_data?: unknown
  review?: unknown
  service?: unknown
  images?: unknown[]
  reviewPhotoShared?: boolean
  booksyAwardsShare?: boolean
  portfolioBackgroundsDrawerOpened?: boolean
  reviewsDrawerOpened?: boolean
  reviewsBackgroundsDrawerOpened?: boolean
  scenario?: string
}

export type InventoryDocumentCreateFlashData = {
  selectedProducts?: Array<string | number>
}

export type BcrConnectFlashData = {
  reader?: Reader
}

export type MessageClientsOptionsFlashData = {
  template?: Record<string, unknown>
  scheduled?: boolean
  tab?: unknown
  query?: string
  isCustomBlastFromPreview?: boolean
  stopCode?: unknown
  blastId?: string | number
  openActiveCampaginTab?: boolean
  openQueueCampaginTab?: boolean
  customers?: unknown
  sendToCount?: number
}

export type MessageClientsPromotionsTemplateFlashData = Record<string, unknown>

export type FlashDataKey = typeof FLASH_DATA_KEYS[keyof typeof FLASH_DATA_KEYS]
